import { logSafelyToConsole } from 'utils';
import { POST } from 'utils/useApi';
import {
  TutorCruncherSignupInputUser,
  TutorCruncherSignupResponse
} from 'types/Api';

export enum TutorCruncherSignUpTutorActionType {
  TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST = 'TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST',
  TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS = 'TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS',
  TUTORCRUNCHER_SIGNUP_TUTOR_ERROR = 'TUTORCRUNCHER_SIGNUP_TUTOR_ERROR'
}

export const requestSignUpTutor = async (
  user: TutorCruncherSignupInputUser,
  dispatch: React.Dispatch<{
    type: TutorCruncherSignUpTutorActionType;
    payload: { response: TutorCruncherSignupResponse } | null;
  }>
): Promise<void> => {
  const {
    TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST,
    TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS,
    TUTORCRUNCHER_SIGNUP_TUTOR_ERROR
  } = TutorCruncherSignUpTutorActionType;

  dispatch({
    type: TUTORCRUNCHER_SIGNUP_TUTOR_REQUEST,
    payload: null
  });

  const { REACT_APP_TUTORCRUNCHER_ADMINISTRATOR_ID } = process.env;

  if (REACT_APP_TUTORCRUNCHER_ADMINISTRATOR_ID) {
    try {
      const useToken = false;
      const response = (await POST(
        'v3/tutorcruncher/contractors/',
        user,
        useToken
      )) as TutorCruncherSignupResponse;

      logSafelyToConsole({ response });
      if (response) {
        dispatch({
          type: TUTORCRUNCHER_SIGNUP_TUTOR_SUCCESS,
          payload: { response }
        });
      } else {
        dispatch({
          type: TUTORCRUNCHER_SIGNUP_TUTOR_ERROR,
          payload: null
        });
      }
    } catch (err) {
      dispatch({
        type: TUTORCRUNCHER_SIGNUP_TUTOR_ERROR,
        payload: null
      });
    }
  } else {
    dispatch({
      type: TUTORCRUNCHER_SIGNUP_TUTOR_ERROR,
      payload: null
    });
  }
};
